export const CONDITION_LAYOUT_DATA_TEST = {
  conditionLayout: 'qb-ui-condition-layout',
  actionButtons: 'qb-ui-condition-action-buttons',
};
